import { UnleashClient } from 'unleash-proxy-client';

const FRONT_ENV_FULL: Record<string, string> = {
  dev: 'development',
  stage: 'stage',
  prod: 'production'
};

export const unleashConfig = {
  url: process.env.UNLEASH_URL!,
  clientKey: process.env.UNLEASH_CLIENT_KEY!,
  appName: String(process.env.BUILD_NUMBER),
  environment: FRONT_ENV_FULL[process.env.FRONT_ENV!],
};

export const unleashClient = new UnleashClient(unleashConfig); 